import store, {types as storeTypes} from '../vuex'
import emojUtil from './emojson'
export default function ($http) {
    return {
        initials() {
            return $http
                .get('/api/ent/home/initials', {
                    handleError : false
                })
                .then(({data}) => {
                    //console.log(data);
                    store.commit(storeTypes.SET_COMMON, data.data);
                    data.data.user.userDeptSet = data.data.userDeptSet;
                    store.commit(storeTypes.SET_USER, data.data.user);
                    store.commit(storeTypes.SET_USER_FEATURE, data.data.userFeature);
                    return data.data
                })
                .catch((res) => {
                    return {}
                })
        },
        string2Date(str) {
            var me = this;
            str = str.replace("T", " ");
            var arr = str.split(' ');
            var date = new Date();
            if (arr.length > 0) {
                var arr1 = arr[0].split('-');
                if (arr1.length == 3) {
                    date.setYear(parseInt(arr1[0]));
                    date.setMonth(parseInt(arr1[1]) - 1);
                    date.setDate(parseInt(arr1[2]));
                }
            }
            if (arr.length > 1) {
                var arr2 = arr[1].split(":")
                if (arr2.length >= 2) {
                    date.setHours(parseInt(arr2[0]));
                    date.setMinutes(parseInt(arr2[1]));
                }
                if (arr2.length == 3) {
                    var arr3 = arr2[2].split(".");
                    if (arr3.length >= 1) {
                        date.setSeconds(parseInt(arr3[0]));
                    }
                    if (arr3.length == 2) {
                        date.setMilliseconds(parseInt(arr3[1]));
                    }
                }
            }
            return date;
        },
        fsUrl(value, thumbnail) {
            if (value && value.startsWith("n:")) {
                thumbnail = thumbnail || 'm';
                let replacement;
                if(window.fsSeePath){
                    replacement = window.fsSeePath+'/$2$3';
                    if (thumbnail !== 'o') {
                        replacement = window.fsSeePath+'/$2_' + thumbnail + '$3';
                    }
                }else{
                    replacement = 'http://fs-$1.360ease.com/$2$3';
                    if (thumbnail !== 'o') {
                        replacement = 'http://fs-$1.360ease.com/$2_' + thumbnail + '$3';
                    }
                }
                return value.replace(/n:([^\/]+)\/([^\.]+)((\.?).*)/, replacement);
            }
            return value;
        },
        toEmoji(value){
            if(!value) return value;
            //let reg = /(\[([^\]]+)\])|(\/:{1,2}\S+)/g;
            let f = (reg) =>{
                value = value.replace(eval(reg), ($1) => {
                    let key = emojUtil.wxToHan[$1];
                    if (key) {
                        return emojUtil.showEmojiData[key] || key;
                    }else{
                        return $1;
                    }
                });
            };
            for(let i=1;i<5;i++) {
                let reg = '/\\/:{1,2}\\S{'+i+'}/g';
                f(reg);
            }
            f('/\\/:{1,2}[a-zA-Z]{1,9}/g');
            f('/\\/:/g');
            value = value.replace(/\[([^\]]+)\]/g, ($1) => {
                return emojUtil.showEmojiData[$1] || $1;
            });
            return value;
        }
    }
}



// WEBPACK FOOTER //
// ./src/api/base.js